import React from 'react';
import { Router } from '@reach/router'
import Dashboard from "./components/Dashboard";

const App = props => {
    return (
        <Router basepath="/info">
            <Dashboard path="/*" />
        </Router>
    );
};

export default App;
